import React from 'react';
import { motion } from 'framer-motion';
import { FiCpu, FiTrendingUp, FiZap, FiTarget } from 'react-icons/fi';
import { Line } from 'react-chartjs-2';

const AIAnalytics = () => {
  const predictionData = {
    labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
    datasets: [
      {
        label: 'Predicted Sales',
        data: [4500, 5200, 4800, 6100],
        borderColor: '#06b6d4',
        backgroundColor: 'rgba(6, 182, 212, 0.2)',
        fill: true,
        tension: 0.5,
      },
    ],
  };

  return (
    <div className="container-fluid p-0">
      <div className="d-flex justify-content-between align-items-center mb-5">
        <div>
          <h2 className="fw-bold mb-1 neon-text">AI Intelligence Hub</h2>
          <p className="text-muted small mb-0">Predictive modeling and automated business insights.</p>
        </div>
        <div className="badge bg-primary bg-opacity-10 text-primary p-2 px-3 border border-primary border-opacity-20 d-flex align-items-center gap-2">
          <FiCpu className="spinner-animation" /> AI Engine Active
        </div>
      </div>

      <div className="row g-4">
        <div className="col-xl-4">
          <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} className="glass-card p-4 h-100 neon-border">
            <div className="d-flex align-items-center gap-3 mb-4">
              <div className="p-3 rounded-circle bg-info bg-opacity-10 text-info">
                <FiZap size={24} />
              </div>
              <h5 className="fw-bold mb-0">Sales Prediction</h5>
            </div>
            <p className="text-muted small mb-4">Our AI models predict a 24% increase in demand for cold beverages across 5 branches next week.</p>
            <div style={{ height: '200px' }}>
              <Line data={predictionData} options={{ maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { x: { display: false }, y: { display: false } } }} />
            </div>
          </motion.div>
        </div>

        <div className="col-xl-8">
          <div className="row g-4 h-100">
            <div className="col-md-6">
              <div className="glass-card p-4 h-100">
                <FiTarget className="text-primary mb-3" size={32} />
                <h6 className="fw-bold mb-2">Inventory Optimization</h6>
                <p className="text-muted small">AI suggests reducing stock of "Winter Special Beans" by 15% to minimize waste based on seasonal trends.</p>
                <button className="btn btn-sm btn-outline-primary mt-auto">Apply Recommendation</button>
              </div>
            </div>
            <div className="col-md-6">
              <div className="glass-card p-4 h-100">
                <FiTrendingUp className="text-success mb-3" size={32} />
                <h6 className="fw-bold mb-2">Market Sentiment</h6>
                <p className="text-muted small">Real-time analysis shows positive feedback on new "Eco-friendly Packaging" in metropolitan areas.</p>
                <div className="progress bg-dark bg-opacity-50 mt-3" style={{ height: '8px' }}>
                  <div className="progress-bar bg-success" style={{ width: '88%' }}></div>
                </div>
                <div className="d-flex justify-content-between mt-1 small text-muted">
                  <span>Sentiment Score</span>
                  <span>88% Positive</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx="true">{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .spinner-animation {
          animation: spin 3s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default AIAnalytics;
